import React from 'react';

import PropTypes from 'prop-types';

import MarkdownField from 'components/fields/MarkdownField';
import { MarkdownButtonPlugin } from 'components/fields/MarkdownField/components';
import StyleConfigurationTable from 'components/modules/custom-pages/components/StyleConfigurationTable';

import { CSS_RULES } from './MarkdownTextOptions.constants';
import { FormFieldPropType } from '../../../../../../../../types/form-block.types';

import './MarkdownTextOptions.scss';

const propTypes = {
  field: FormFieldPropType.isRequired,
  onUpdateFieldValue: PropTypes.func.isRequired,
};

const defaultProps = {};

export default function MarkdownTextOptions({ field, onUpdateFieldValue }) {
  const { content = '', style = {} } = field;

  function onContentChange(nextContent) {
    onUpdateFieldValue('content', nextContent);
  }

  function onStyleChange(e, { value }) {
    onUpdateFieldValue('style', value);
  }

  return (
    <div className="markdown-text-options">
      <div className="label">Content</div>
      <MarkdownField
        value={content}
        onChange={onContentChange}
        placeholder="Enter markdown content"
        toolbarPlugins={[MarkdownButtonPlugin]}
        options={{
          autoDisplaySideBySidePreview: false,
          minHeight: '150px',
        }}
      />

      <div className="label">Style</div>
      <StyleConfigurationTable cssRules={CSS_RULES} style={style} onChange={onStyleChange} />
    </div>
  );
}

MarkdownTextOptions.propTypes = propTypes;
MarkdownTextOptions.defaultProps = defaultProps;
